module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_pp2_8017.b7e2933f.png";